define([
        "language/resource",
        "authui/iamUtils",
    ], function (i18n, iamUtils) {
        "use strict";
        function ErrorController($scope) {
            var images = {
                error_401: require('base/error/theme/default/images/error-401.png'),
                error_404: require('base/error/theme/default/images/error-404.png'),
                error_500: require('base/error/theme/default/images/error-500.png'),
            };                
            var errorCodeMap =  {
                'O001': i18n('OIDC.errorO001'),
                'O002': i18n('OIDC.errorO002'),
                'O003': i18n('OIDC.errorO003'),
                'O004': i18n('OIDC.errorO004'),
                'O005': i18n('OIDC.errorO005'),
                'O006': i18n('OIDC.errorO006'),
                'O007': i18n('OIDC.errorO007'),
                'O008': i18n('OIDC.errorO008'),
                'O009': i18n('OIDC.errorO009'),
                'O010': i18n('OIDC.errorO010'),
                'O011': i18n('OIDC.errorO011'),
                'O012': i18n('OIDC.errorO012'),
                'O013': i18n('OIDC.errorO013'),
                'O014': i18n('OIDC.errorO014'),
                'O015': i18n('OIDC.errorO015'),
                '401': i18n('console_term_401Error_label'),
                '404': i18n('console_term_404Error_label'),
                '500': i18n('console_term_500Error_label'),
                'L0001': i18n('clientIpInvalid'),
                'L0002': i18n('userNotExist'),
                'L0003': i18n('error.L0003'),
            };
            var params = getParams();

            //存在错误码
            $scope.errorCode = params.error_code;
            if (params.error_code) {
                if (errorCodeMap[params.error_code]) {
                    $scope.errorMsg = errorCodeMap[params.error_code]; 
                } else if (params.error_description) {
                    $scope.errorMsg = params.error_description;
                } else {
                    //存在非已知错误码，但是没有error_description
                    $scope.errorMsg = i18n('OIDC.errorDefault');
                }
            } else {
                window.location.replace(iamUtils.CONFIG.homepageUrl);
            }

            if (params.error_code === '401') {
                $scope.errorImg = images.error_401;
            } else if (params.error_code === '404') {
                $scope.errorImg = images.error_404;
            } else if (params.error_code === '500') {
                $scope.errorImg = images.error_500;
            } else {
                $scope.errorImg = images.error_401;
            }
        };

        function getParams() {
            var search = window.location.search;
            if(!search || search.charAt(0) !== '?') {
                return {};
            } else {
                search = search.slice(1);
            }
            var result = {};
            var splitted = search.split('&');
            var index, item;
            for(index = 0; index < splitted.length; index ++) {
                item = splitted[index].split('=');
                if(item.length === 2 && item[0] && item[1]) {
                    try {
                        result[item[0]] = decodeURIComponent(item[1]).replace(/\+/g, ' ');
                    } catch(e) {}
                }
            }
            return result;
        }

        ErrorController = ["$scope", ErrorController];

        var loginModule = angular.module('authui.config');
        loginModule.controller('authui.error.ctrl', ErrorController);

        return ErrorController;
    }
);


// WEBPACK FOOTER //
// ./public/hws/js/error/controllers/errorController.js